export const defaultStyles = `
html, body {
    all: unset;
}

a, a:visited, a:hover, a:active {
    color: inherit;
}
`;
